'use strict'
import configurazioni from '@/services/configurazioniService.js'

var config, service, fidelity;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  fidelity = config.VUE_APP_MOL_S_FIDELITY
}

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${fidelity}/cicleSync`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ multiplo })
    })
    return await response.json()
  } catch (error) {
    return null
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${fidelity}/mode`)
    const result = await response.json()
    if (result.status === 404) {
      return defaultRunMode()
    }
    return result
  } catch {
    return defaultRunMode()
  }
}

function defaultRunMode() {
  return {
    modulo: 'FIDELITY',
    locale: '---',
    remote: '---',
    versione: '---',
    health: '---'
  }
}

async function getFidelity(barcode) {
  if (!config || !service) {
    await getConfigFile();
  }
  if (!barcode) {
    return
  }
  const response = await fetch(`${service}/${fidelity}/${barcode}`)
  return await response.json()
}

async function creaBuonoMultiuso(idCassa, importo) {
  if (!config || !service) {
    await getConfigFile();
  }
  var barcode = await configurazioni.getBarcodeInfo('buonomultiuso')
  const data = {
    prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, '0')}`,
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
    importo
  }
  const response = await fetch(`${service}/${fidelity}/create/buono`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  const buonoCreato = await response.json()
  await configurazioni.setBarcodeInfo('buonomultiuso', 'write', buonoCreato.ultimoNumero)
  return buonoCreato
}

async function aggiornaBuonoMultiuso(card) { // solo il contenuto di buono, non tutta la card ?!
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/${card._id}/update/buono`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(card.buono)
  })
  return await response.json()
}

async function creaBuonoMonouso(idCassa, importo) {
  if (!config || !service) {
    await getConfigFile();
  }
  var barcode = await configurazioni.getBarcodeInfo('buonomonouso')
  const data = {
    prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, '0')}`,
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
    importo
  }
  const response = await fetch(`${service}/${fidelity}/create/monouso`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  const buonoCreato = await response.json()
  await configurazioni.setBarcodeInfo('buonomonouso', 'write', buonoCreato.ultimoNumero)
  return buonoCreato
}

async function aggiornaBuonoMonouso(card) { // solo il contenuto di buono, non tutta la card ?!
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/${card._id}/update/monouso`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(card.buono)
  })
  return await response.json()
}

async function aggiornaPrepagata(card) { // solo il contenuto di buono, non tutta la card ?!
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/${card._id}/update/prepagata`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(card.buono)
  })
  return await response.json()
}

async function aggiornaAccesso(id, accesso) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/${id}/update/accesso`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(accesso)
  })
  return await response.json()
}

async function aggiornaInfoAcquistoCard(codice, infoAcquisto, importo) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    infoAcquisto,
    importo
  }
  const response = await fetch(`${service}/${fidelity}/${codice}/update/acquisto`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function creaFidelityCard(idCassa) {
  if (!config || !service) {
    await getConfigFile();
  }
  var barcode = await configurazioni.getBarcodeInfo('fidelitycard')
  const data = {
    prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, '0')}`,
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice
  }
  const response = await fetch(`${service}/${fidelity}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  const fidelityCreata = await response.json()
  await configurazioni.setBarcodeInfo('fidelitycard', 'write', fidelityCreata.ultimoNumero)
  return fidelityCreata.card
}

async function creaFidelityCardCliente(idCassa, dati, cliente) {
  if (!config || !service) {
    await getConfigFile();
  }
  var barcode = await configurazioni.getBarcodeInfo('fidelitycard')
  const data = {
    prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, '0')}`,
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
    dati: dati,
    cliente: cliente
  }
  const response = await fetch(`${service}/${fidelity}/create/customer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  const fidelityCreata = await response.json()
  await configurazioni.setBarcodeInfo('fidelitycard', 'write', fidelityCreata.ultimoNumero)
  return fidelityCreata.card
}

async function aggiornaFidelity(codiceFidelity, dati) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/${codiceFidelity}/update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dati)
  })
  return await response.json()
}

async function associaFidelity(codiceFidelity, codiceCliente, ragioneSociale) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    codice: codiceCliente,
    ragioneSociale
  }
  const response = await fetch(`${service}/${fidelity}/${codiceFidelity}/update/associa`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function deleteFidelity(code, utente, operatore) { // inserisce il record di annullamento
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    code,
    utente,
    operatore
  }
  const response = await fetch(`${service}/${fidelity}/delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function creaCardAccessiCliente(dati, cliente) {
  if (!config || !service) {
    await getConfigFile();
  }
  var barcode = await configurazioni.getBarcodeInfo('accesso')
  const data = {
    prefisso: barcode.prefisso,
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
    dati: dati,
    cliente: cliente
  }
  const response = await fetch(`${service}/${fidelity}/create/customer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  const cardCreata = await response.json()
  await configurazioni.setBarcodeInfo('accesso', 'write', cardCreata.ultimoNumero)
  return cardCreata.card
}

async function cercaFidelityByCode(code, len, associata = true, type = 'multiuso') {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/search?code=${code}&len=${len}&associata=${associata}&type=${type}`)
  return await response.json()
}

async function cercaFidelityById(id, len, associata = true, type = 'multiuso') {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/search?id=${id}&len=${len}&associata=${associata}&type=${type}`)
  return await response.json()
}

async function cercaFidelityByTicket(ticket, len, associata = true, type = 'multiuso') {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/search?ticket=${ticket}&len=${len}&associata=${associata}&type=${type}`)
  return await response.json()
}

async function cercaFidelityByPurchaseTicket(ticket, len, associata = true, type = 'multiuso') {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/search?purchase=${ticket}&len=${len}&associata=${associata}&type=${type}`)
  return await response.json()
}

async function cercaFidelityByCliente(type = 'multiuso', codiceCliente) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${fidelity}/search?customer=${codiceCliente}&type=${type}`)
  return await response.json()
}

export default {
  cicleSync,
  getRunMode,
  getFidelity,
  creaBuonoMultiuso,
  aggiornaBuonoMultiuso,
  aggiornaInfoAcquistoCard,
  aggiornaAccesso,
  creaFidelityCard,
  creaFidelityCardCliente,
  aggiornaFidelity,
  aggiornaPrepagata,
  associaFidelity,
  deleteFidelity,
  creaCardAccessiCliente,
  cercaFidelityByCode,
  cercaFidelityById,
  cercaFidelityByTicket,
  cercaFidelityByPurchaseTicket,
  cercaFidelityByCliente,
  creaBuonoMonouso,
  aggiornaBuonoMonouso
}
